<template>
<div class="modal is-large is-active">
    <div class="modal-background"></div>
    <div class="modal-content">
        <div class="custom-modal-box">
            <div class="default-settings-title">
                <span class="account-name">Backup details</span>
                <span class="default-settings-subtitle">{{ backupDescription }}</span>
            </div>

            <div class="backup" style="margin-bottom: 35px;">
                <div class="columns is-multiline">
                    <div class="column is-full">
                        <div class="highlight" style="border-radius: 5px; max-height: 350px; overflow-y: scroll !important;" id="logs-output">
                            <pre v-if="loadedOnce && logs.length > 0" style="background-color: #1B2738 !important;"><code :class="{ 'warning-text': warningTextShouldBeDisplayed(log), 'err-text': errorTextShouldBeDisplayed(log), 'out-text': outTextShouldBeDisplayed(log) }" v-for="log in logs"><span v-if="showLine(log.text.S)">{{ log.text.S }}</span></code><img v-if="refreshedFileBackup.status == 'in_progress' || refreshedFileBackup.status == 'pending'" style="display: inline-block; padding-top:20px;" src="/loader-circle-empty-light.svg"></pre>
                            <pre v-if="loadedOnce && logs.length == 0 && refreshedFileBackup.status !== 'pending'" style="background-color: #1B2738 !important;"><code class="out-text"><span>There are no logs to be displayed.</span></code></pre>
                            <pre v-if="!loadedOnce && refreshedFileBackup.status !== 'pending'" style="background-color: #1B2738 !important; text-align:center;"><img src="/loader-circle-empty-light.svg"></pre>
                        </div>
                    </div>
                    <div class="column is-3" v-if="refreshedFileBackup.status == 'in_progress'">
                        <div @click="toggleAutoScroll" class="button is-small is-fullwidth is-info" style="border-radius: 5px;">
                            <font-awesome-icon v-if="!autoScroll" icon="play" class="dropdown-action-icon" style="color:white" />
                            <font-awesome-icon v-if="autoScroll" icon="pause" class="dropdown-action-icon" style="color:white" />
                            <span v-show="!autoScroll">Resume auto-scroll</span>
                            <span v-show="autoScroll">Pause auto-scroll</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div class="columns is-multiline" style="margin-top: 10px;"> -->
                <!-- <div class="column is-3">
                    <div @click="changeEncryption" :disabled="saveButtonDisabled" :class="{ 'is-loading': changingEncryptionKey }" class="button custom-button-size is-fullwidth is-info">{{ saveButtonText }}</div>
                </div> -->
                <!-- <div class="column is-3">
                    <div @click="close" class="close-add-monitor-modal button custom-button-size is-fullwidth is-danger">Close</div>
                </div> -->
            <!-- </div> -->
        </div>
    </div>
    <button @click="close" class="modal-close is-large" aria-label="close"></button>
</div>
</template>

<style scoped>
.err-text {
    color: rgb(255, 86, 48);
}
.out-text {
    color: white;
    /* color: rgb(54, 179, 126); */
}
.warning-text {
    color: rgb(255, 171, 0);
}
html {
  scroll-behavior: smooth;
}
</style>

<script>
import Api from '@/api';
import Swal from 'sweetalert2';

export default {
    props: ['database', 'fileBackup'],

    data() {
        return {
            restores: [],
            loadingRestores: false,
            restoresLoadedOnce: false,
            page: 1,
            logs: null,
            refreshedFileBackup: null,
            interval: null,
            autoScroll: true,
            loadedOnce: false,
        }
    },

    mounted() {
        this.refreshedFileBackup = this.fileBackup;
        let vm = this;

        this.getFileBackupLogs(() => {
            // if (this.autoScroll) {
                vm.updateScroll();
            // }
        });

        this.listenEvents();

        Echo.private('file_backup.' + this.fileBackup.id)
            .listen('SshLogLineCreated', (e) => {
                this.getFileBackupLogs(() => {
                    this.refreshFileBackup();
                    if (this.autoScroll) {
                        this.updateScroll();
                    }
                })
            });
    },

    beforeDestroy() {
        clearInterval(this.interval);
        Echo.leave('file_backup.' + this.fileBackup.id);
    },

    methods: {
        updateScroll(){
            console.log('scroll called');
            var element = document.getElementById("logs-output");
            if (element) {
                console.log('element found');
                console.log(element.scrollHeight);
                element.scrollTop = element.scrollHeight;
            } else {
                console.log('element not found');
            }
        },

        close() {
            Event.$emit('fileBackupDetailsModalClosed');
        },

        errorTextShouldBeDisplayed(log) {
            if (log.type.S == 'err') {
                return true;
            }

            if (log.text.S.substring(0, 5) == 'ERROR') {
                return true;
            }

            return false;
        },

        warningTextShouldBeDisplayed(log) {
            if (this.errorTextShouldBeDisplayed(log) && log.text.S.substring(0, 8) == 'Warning:') {
                return true;
            }

            return false;
        },

        outTextShouldBeDisplayed(log) {
            if (!this.errorTextShouldBeDisplayed(log)) {
                return true;
            }
        },

        getFileBackupLogs(successCallback) {
            Api().get('logs-v2?log_origin_type=file_backup&log_origin_id=' + this.fileBackup.id)
                .then((success) => {
                    this.logs = success.data;

                    if (typeof successCallback === 'function') {
                        successCallback();
                    }

                    Vue.nextTick(() => {
                        if (!this.loadedOnce) {
                            this.loadedOnce = true;
                        }
                    });
                })
                .finally(() => {
                    
                });
        },

        refreshFileBackup() {
            Api().get('file-backups/' + this.fileBackup.id)
                .then((success) => {
                    this.refreshedFileBackup = success.data.data;
                });
        },

        getRestores() {
            if (this.loadingRestores) {
                return;
            }

            this.loadingRestores = false;

            Api().get('databases/' + this.database.id + '/restores?page=' + this.page)
                .then((success) => {
                    this.restores = success.data;
                })
                .finally(() => {
                    this.loadingRestores = false;
                    this.restoresLoadedOnce = true;
                });
        },

        paginatePrevPage() {

        },

        paginateNextPage() {

        },

        listenEvents() {
            //
        },

        statusIs(status, restore) {
            return status === restore.status;
        },

        statusLabel(restore) {
            if (this.statusIs('completed', restore)) {
                return 'Completed';
            }
            if (this.statusIs('pending', restore)) {
                return 'Pending';
            }
            if (this.statusIs('in_progress', restore)) {
                return 'In progress';
            }
            if (this.statusIs('errored', restore)) {
                return 'Failed';
            }
        },

        showLine(line) {
            var ignored = [
                'starting with parameters ["/tmp/.weap.io/rclone"',
                'Using config file from ',
            ];

            for (var i = 0; i < ignored.length; i++) {
                if (line.includes(ignored[i])) {
                    return false;
                }
            }

            return true;
        },

        toggleAutoScroll() {
            this.autoScroll = !this.autoScroll;
        },
    },

    computed: {
        hasRestores() {
            if (typeof this.restores.data === 'undefined') {
                return false;
            }

            return this.restores.data.length > 0;
        },

        hasMoreThanOnePage() {
            if (!this.hasRestores) {
                return false;
            }

            if (typeof this.restores.meta === 'undefined') {
                return false;
            }

            return this.restores.meta.last_page > 1;
        },

        prevPageAvailable() {
            if (typeof this.restores.meta === 'undefined') {
                return false;
            }

            return this.restores.meta.current_page > 1 && !this.loadingRestores;
        },

        nextPageAvailable() {
            if (typeof this.restores.meta === 'undefined') {
                return false;
            }

            return this.restores.meta.current_page < this.restores.meta.last_page && !this.loadingRestores;
        },

        backupDescription() {
            if (!this.refreshedFileBackup) {
                return '';
            }

            if (this.refreshedFileBackup.status == 'completed') {
                return this.refreshedFileBackup.file_name;
            }

            if (this.refreshedFileBackup.status == 'in_progress') {
                return 'Backup in progress...';
            }
            
            if (this.refreshedFileBackup.status == 'errored') {
                return 'Backup errored.';
            }

            return 'Waiting for a worker...';
        },
    },

    watch: {
        autoScroll(autoScroll) {
            if (autoScroll) {
                this.updateScroll();
            }
        },

        refreshedFileBackup(newRefreshedFileBackup, oldRefreshedFileBackup) {
            if (this.autoScroll && (newRefreshedFileBackup.status == 'completed' || newRefreshedFileBackup.status == 'errored')) {
                var vm = this;
                setTimeout(function() {
                    vm.getFileBackupLogs(() => {
                        vm.updateScroll();
                    })
                }, 1500);
            }
        },
    },
}
</script>
